import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';
import axios from 'axios';
import Configuration from '../../Config';
import { useParams, useNavigate } from "react-router-dom";
import MenuForm from './MenuForm';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Input = styled('input')({
  display: 'none',
});

export default function EditItemMenu() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [item, setItem] = useState({});
    useEffect(async () => {
        fetchMenuItem(id);
    }, []);
      
    const fetchMenuItem = (id) => {
        let token = localStorage.getItem("token");
        axios.get(Configuration.BASE_URL + "/menu/" + id, { headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          setItem(response.data);
        }).catch(function (error) {
          console.log(error);
        });
    } 

    const handleSubmit = (formData) => {
        let token = localStorage.getItem("token");
        axios.post(Configuration.BASE_URL + "/menu/edit/" +  id , formData, { headers: { Authorization: 'Bearer ' + token, "Content-Type": "multipart/form-data" } })
        .then((response) => {
            navigate("/menu/"+item.language);
        }).catch((error) => {
        });
    };

    return (
        <Grid item xs={12} md={12} lg={12}>
        <Paper
        sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
        }}
        > 
        <Grid item md={12}>
            <IconButton onClick={() => navigate('/menu/' + item.language) } aria-label="qrcode">
                <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5" color="text.secondary" align="center">
                Editar Item
            </Typography>
            {item ? <MenuForm handleSubmit={handleSubmit} editing={true} item={item} />
            : <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }}><CircularProgress /></Box>
            }
        </Grid>
        </Paper>
    </Grid>
    );
}
